import { IFilterGroup, ILayer, ILayerGroup, IUrl } from "./ILayer";

/**
 * Estructura dels fitxers guia_xxx.json, fitxurb_xxx.json, ...
 */

// Totes les defincions necessàries pel programa
export interface IMapConfig {
    title: string, // Títol del mapa [M]
    baseLayers: ILayer[], // Capes base [G,FU,M,LL]
    refLayers: (ILayer | ILayerGroup)[], // Capes de referència [G,FU,M,LL] per [M40,GRSMM] només una capa de referència
    filters: IFilterGroup[], // Filtres [M40, GRSMMM]
    nomsLayer: ILayer, // Capa de noms de carrer [G,FU,M,LL]
    txconsLayer: ILayer, // Capa de texts d'edificació [FU,M,LL]
    parceLayer: ILayer, // Capa de parcel·les d'urbana. Ha de ser tipus WMS [G,FU,M,LL]
    rparceLayer: ILayer, // Capa de parcel·les de rústica. Ha de ser tipus WMS [G,FU,M,LL]
    pllicLayer: ILayer, // Capa de llicències. Ha de ser tipus WMS [LL]
    adrLayer: ILayer, // Capa d'adreces. Ha de ser tipus WMS [G,M]
    selLayer: ILayer, // Capa de selecció. Ha de ser tipus WMS [M]
    projCode: string, // Nom de la projecció a utilitzar. p.ex.: 'EPSG:25831' [Tots]
    proj4Defs: string, // Definció de la projecció en format Proj4. p.ex.: '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs' [Tots]
    initialExtent: [number, number, number, number], // Extensió inicial del mapa. p.ex.: '[397000, 4615700, 408700, 4623700]' [Tots]
    maxExtent: [number, number, number, number], // Extensió màxima del mapa. Si no hi és agafa l'initialExtent p.ex.: '[397000, 4615700, 408700, 4623700]' [Tots]
    scaleBar: boolean, // Diu si volem que aparegui la barra d'escala [Tots]
    measureTool: boolean, // Diu si volem que apareguin les eines de mesura [Tots]
    infoType: number, // 0 -> Informació com la de la guia, 1 -> Informació complerta [M]
    helpUrl: string, // Url de la pantalla d'ajuda [Tots]
    wfsUrl: string, // URL del WFS estàndard [G,FU,M]
    wsGuia: string, // URL del WbService de la Guia [G,FU,M]
    wsFitxUrb : string, // URL del WbService de la Fitxa Urbanistica [FU]
    wsPhoto: string, // URL del WbService de les fotos de les façanes [G,M]
    wsSig: string, // URL del WebService del SIG [FU]
    refCadWebApiUrl: string, // URL del WebAPi del widget de la referència cadastral [G,M]
    descarrega: IUrl[], // URLs a afegir al desplegable de descàrregues [G,M]
    minZoom: number, // Zoom mínim [Tots] 12
    maxZoom: number, // Zoom màxim [Tots] Per intranet 20, per internet 19
    initialZoom: number, // Zoom inicial 14. Si no hi és agafa el minZoom [Tots]
    habUrl: string, // URL de la pantalla d'habitants [FU]
    bbddUrl: string // URL de la pantalla del banc de dades [FU]
}

// Confiuració buida per inicialitzar
export class EmptyMapConfig implements IMapConfig {
    title = ''; // Títol del mapa [M]
    baseLayers = []; // Capes base [G,FU,M]
    refLayers = []; // Capes base [G,FU,M] per [M40,GRSMM] només una capa de referència
    filters = []; // Filtres [M40, GRSMMM]
    nomsLayer = undefined; // Capa de noms de carrer [G,FU,M]
    txconsLayer = undefined; // Capa de texts d'edificació [FU]
    parceLayer = undefined; // Capa de parcel·les d'urbana. Ha de ser tipus WMS [G,FU,M]
    pllicLayer = undefined; // Capa de llicències. Ha de ser tipus WMS [LL]
    rparceLayer = undefined; // Capa de parcel·les de rústica. Ha de ser tipus WMS [G,FU,M]
    adrLayer = undefined; // Capa d'adreces. Ha de ser tipus WMS [G,M]
    selLayer = undefined; // Capa de selecció. Ha de ser tipus WMS [M]
    projCode = ''; // Nom de la projecció a utilitzar. p.ex.: 'EPSG:25831' [Tots]
    proj4Defs = ''; // Definció de la projecció en format Proj4. p.ex.: '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs' [Tots]
    initialExtent = [0, 0, 0, 0] as [number, number, number, number]; // Extensió inicial del mapa. p.ex.: '[397000, 4615700, 408700, 4623700]' [Tots]
    maxExtent: [0, 0, 0, 0]; // Extensió màxima del mapa. Si no hi és agafa l'initialExtent p.ex.: '[397000, 4615700, 408700, 4623700]' [Tots]
    scaleBar = false; // Diu si volem que aparegui la barra d'escala [Tots]
    measureTool = false; // Diu si volem que apareguin les eines de mesura [Tots]
    infoType = 0; // 0 -> Informació com la de la guia, 1 -> Informació complerta [M]
    helpUrl = ''; // Url de la pantalla d'ajuda [Tots]
    wfsUrl = ''; // URL del WFS estàndard [G,FU,M]
    wsGuia = ''; // URLS del WbService de la Guia [G,FU,M]
    wsFitxUrb = ''; // URL del WbService de la Fitxa Urbanistica [FU]
    wsPhoto = ''; // URL del WbService de les fotos de les façanes [G,M]
    wsSig = ''; // URL del WebService del SIG [FU]
    refCadWebApiUrl = ''; // URL del WebAPi del widget de la referència cadastral [G,M]
    descarrega = []; // URLs a afegir al desplegable de descàrregues [G,M]
    minZoom = 0; // Zoom mínim [Tots] 12 (lo més allunyat)
    maxZoom = 0; // Zoom màxim [Tots] Per intranet 20, per internet 19 (lo més aprop)
    initialZoom = 0; // Zoom inicial 14. Si no hi és agafa el minZoom [Tots]
    habUrl = ''; // URL de la pantalla d'habitants [FU]
    bbddUrl = ''; // URL de la pantalla del banc de dades [FU]
}